import * as ACTIONS from 'ReduxLoop/ouManager/invoicing/invoicingActions';
import { emailAddressPattern } from '../../module/personUtils';
import { PEPPOL_METHOD } from '../../reduxLoop/constants';

export class InvoicingTab {
  constructor($scope, $ngRedux, $uibModal) {
    'ngInject';

    this.$scope = $scope;
    this.$ngRedux = $ngRedux;
    this.$uibModal = $uibModal;
    this.mailIcon = require('Img/invoice_outline.svg');
    this.deleteIcon = require('Img/delete.svg');

    this.emailPattern = {
      pattern: emailAddressPattern,
      message: 'Dit is geen geldig e-mailadres',
    }

    this.glnPattern = {
      pattern: /^[0-9]{13}$/,
      message: 'Dit is geen geldig GLN (Global Location Number), een GLN bestaat uit 13 cijfers',
    }

    this.companyNumberPattern = {
      pattern: /^[0-9]{4}\.[0-9]{3}\.[0-9]{3}$/,
      message: 'Dit is geen geldig Belgisch ondernemingsnummer. Het formaat is 0123.456.789',
    }

    this.PEPPOL_METHOD = PEPPOL_METHOD;

    this.unsubscribe = this.$ngRedux.connect((state) => ({
      ou: state.vm.schoolManager.currentOU,
      userRole: state.vm.schoolManager.currentOU?.userRole,
      governingInstitution: state.vm.schoolManager.currentOU?.governingInstitution,
      invoicing: state.vm.invoicingTab,
      isLoading: state.vm.invoicingTab.isLoading,
    }))(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  $onInit() {
    // We just inititalise the tab when current ou is fetched
    // this.$ngRedux.dispatch(ACTIONS.initialiseAccountingDetailsTab());
    /* this.$scope.$on('onFormValidationChanged', (event, payload) => {
      this.$ngRedux.dispatch(ACTIONS.updateInvoicingForm(payload));
    }); */

    // If peppolMethod is already LOCAL, fetch governed schools
    /* if (this.invoicingDetails?.peppolMethod === this.PEPPOL_METHOD.LOCAL && this.ou?.permalink) {
      this.$ngRedux.dispatch(
        ACTIONS.fetchGovernedSchools(this.ou.permalink)
      );
    } */
  }

  emailGeneralChanged(e, generalEmailAddress) {
    if (!this.invoicingForm.formGroups.email.valid) {
      return;
    }
    this.$ngRedux.dispatch(ACTIONS.updateAccountingEmail(generalEmailAddress));
  }

  emailBouwdossiersChanged(e, emailBouwdossiersAddress) {
    if (!this.invoicingForm.formGroups.emailBouwdossiers.valid) {
      return;
    }
    this.$ngRedux.dispatch(ACTIONS.updateAccountingEmail(emailBouwdossiersAddress, 'BOUWDOSSIERS'));
  }

  peppolMethodChanged(value) {
    if (this.invoicing.peppolMethod === this.PEPPOL_METHOD.LOCAL && value === this.PEPPOL_METHOD.NONE) {
      const confirmModal = this.createGlobalMethodConfirmModal();
      confirmModal.result.then(() => {
        this.$ngRedux.dispatch(ACTIONS.updatePeppolMethod(PEPPOL_METHOD.NONE));
      }).catch(() => {
        this.invoicing.isPeppolEnabled = true;
      });
      return;
    }
    this.$ngRedux.dispatch(ACTIONS.updatePeppolMethod(value));
  }

  onGlobalMethodClick(event) {
    if (this.invoicing.peppolMethod === this.PEPPOL_METHOD.GLOBAL) {
      return;
    }

    // Prevent the radio button from changing until the user confirms
    event.preventDefault();
    
    const confirmModal = this.createGlobalMethodConfirmModal();
    
    confirmModal.result.then(() => {
      // User confirmed - switch to GLOBAL
      this.$ngRedux.dispatch(
        ACTIONS.updatePeppolMethod(this.PEPPOL_METHOD.GLOBAL)
      );
    }).catch(() => {
      // User cancelled - do nothing, stay on LOCAL
    });
  }

  onLocalMethodClick() {
    this.$ngRedux.dispatch(
      ACTIONS.updatePeppolMethod(this.PEPPOL_METHOD.LOCAL)
    );
  }

  createGlobalMethodConfirmModal() {
    return this.$uibModal.open({
      animation: true,
      component: 'myConfirmModal',
      size: 'md',
      backdrop: 'static',
      resolve: {
        confirmationQuestion: () =>
          'Opgelet: alle geregistreerde GLN-nummers worden verwijderd! Ben je zeker?',
        icon: () => this.deleteIcon,
        title: () => 'GLN\'s verwijderen',
      },
    });
  }

  glnChangeHandler(relationHref) {
    return (e, gln) => {
      this.$ngRedux.dispatch(ACTIONS.updateGln(relationHref, gln));
    };
  }

  governingInstitutionPeppolIdentifierChangeHandler = (e, identifier) => {
    this.$ngRedux.dispatch(ACTIONS.updateGoverningInstitutionPeppolIdentifier(this.ou.permalink, identifier));
  }

  companyNumberChanged(e, companyNumber) {
    const digits = companyNumber.replace(/\D/g, '');
    if (digits.length !== 9 && digits.length !== 10) {
      return;
    }
    const digitsWithStartingZero = digits.padStart(10, '0')
    this.companyNumberValue = `${digitsWithStartingZero.slice(0, 4)}.${digitsWithStartingZero.slice(4, 7)}.${digitsWithStartingZero.slice(7, 10)}`;
    this.$ngRedux.dispatch(ACTIONS.updateCompanyNumber(this.companyNumberValue));
  }

}
